import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { ResponseData } from "../common"

export interface RemoveExpiredTagResponseData extends ResponseData {
  data: string
}

export interface RemoveExpiredTagResponse extends AxiosResponse {
  data: RemoveExpiredTagResponseData
}

interface RemoveExpiredTagRequestData {
  priceDropAlertId: string
}

export interface RemoveExpiredTagRequest extends Partial<AxiosRequestConfig> {
  params: RemoveExpiredTagRequestData
}

export function removeExpiredTagApi(
  {
    params,
    method = "put",
    url = `/user/remove-expired-tag/${params.priceDropAlertId}`,
    ...config
  }: RemoveExpiredTagRequest,
  axiosInstance: AxiosInstance,
): Promise<RemoveExpiredTagResponse> {
  return axiosInstance({
    method,
    url,
    ...config,
  }) as Promise<RemoveExpiredTagResponse>
}
